import * as React from 'react';

function SvgUpSetting(props) {
  return (
    <svg viewBox="0 0 268 188" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M86.276 29.387h-73.54C6.253 29.387 1 34.641 1 41.122v89.971c0 6.481 5.254 11.735 11.735 11.735h73.541c6.482 0 11.736-5.254 11.736-11.735v-89.97c0-6.482-5.254-11.736-11.736-11.736z"
        fill="#F0F7FF"
        stroke="#99B9FF"
        strokeWidth={1.64}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.909 45.034a3.13 3.13 0 100-6.258 3.13 3.13 0 000 6.258zm8.606 0a3.13 3.13 0 100-6.259 3.13 3.13 0 000 6.259zm8.606 0a3.13 3.13 0 100-6.259 3.13 3.13 0 000 6.259zM84.712 63.42H11.953a1.174 1.174 0 000 2.346h72.759a1.174 1.174 0 100-2.347zM84.712 99.407H11.953a1.174 1.174 0 000 2.348h72.759a1.174 1.174 0 000-2.347zM11.953 83.76h72.759a1.174 1.174 0 000-2.347H11.953a1.174 1.174 0 100 2.347zM11.953 119.749h72.759a1.174 1.174 0 000-2.347H11.953a1.173 1.173 0 100 2.347z"
        fill="#C2D7FF"
      />
      <path
        d="M61.632 71.634a7.041 7.041 0 100-14.082 7.041 7.041 0 000 14.082zm0 35.988a7.04 7.04 0 100-14.082 7.04 7.04 0 000 14.082zM29.556 75.546a7.041 7.041 0 100 14.082 7.041 7.041 0 000-14.082zm0 35.988a7.04 7.04 0 100 14.082 7.04 7.04 0 100-14.082z"
        fill="#C2D7FF"
      />
      <path
        d="M255.265 21.955h-73.541c-6.482 0-11.736 5.254-11.736 11.735v89.97c0 6.482 5.254 11.736 11.736 11.736h73.541c6.481 0 11.735-5.254 11.735-11.736V33.69c0-6.481-5.254-11.735-11.735-11.735z"
        fill="#F0F7FF"
        stroke="#99B9FF"
        strokeWidth={1.64}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.897 37.602a3.13 3.13 0 100-6.26 3.13 3.13 0 000 6.26zm8.606 0a3.13 3.13 0 100-6.26 3.13 3.13 0 000 6.26zm8.606 0a3.129 3.129 0 100-6.26 3.129 3.129 0 000 6.26zM253.7 55.987h-72.759a1.174 1.174 0 100 2.347H253.7a1.173 1.173 0 000-2.347zM253.7 91.975h-72.759a1.174 1.174 0 100 2.347H253.7a1.173 1.173 0 000-2.347zM180.941 76.328H253.7a1.173 1.173 0 000-2.347h-72.759a1.174 1.174 0 000 2.347zM180.941 112.316H253.7a1.173 1.173 0 100-2.347h-72.759a1.174 1.174 0 000 2.347z"
        fill="#C2D7FF"
      />
      <path
        d="M233.358 64.202a7.042 7.042 0 100-14.084 7.042 7.042 0 000 14.084zm0 35.988a7.042 7.042 0 100-14.084 7.042 7.042 0 000 14.084zm-32.076-32.077a7.04 7.04 0 100 14.082 7.04 7.04 0 000-14.082zm0 35.989a7.041 7.041 0 100 14.082 7.041 7.041 0 000-14.082z"
        fill="#C2D7FF"
      />
      <path
        d="M161.773 51.293h-73.54c-6.482 0-11.736 5.254-11.736 11.735V153c0 6.481 5.254 11.735 11.735 11.735h73.541c6.482 0 11.736-5.254 11.736-11.735v-89.97c0-6.482-5.254-11.736-11.736-11.736z"
        fill="#F0F7FF"
        stroke="#99B9FF"
        strokeWidth={1.64}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.406 66.94a3.13 3.13 0 100-6.259 3.13 3.13 0 000 6.259zm8.606 0a3.131 3.131 0 002.213-5.342 3.131 3.131 0 00-5.343 2.213 3.13 3.13 0 003.13 3.129zm8.606 0a3.13 3.13 0 100-6.26 3.13 3.13 0 000 6.26zM104.662 106.058c7.561 0 13.691-6.13 13.691-13.692 0-7.561-6.13-13.69-13.691-13.69-7.562 0-13.692 6.129-13.692 13.69 0 7.562 6.13 13.692 13.692 13.692zM144.757 66.94l21.851 37.846h-43.701l21.85-37.846zM119.526 109.187h44.594v40.291h-44.594v-40.291zm-5.867 3.912h-7.824v32.467h7.824v-32.467zm-12.518 0h-7.824v32.467h7.824v-32.467z"
        fill="#C2D7FF"
      />
      <path
        d="M121.807 180.999c-.28 2.291-2.461 3.485-6.269 4.633-2.864.863-5.461 1.687-8.832 1.315-2.359-.26-4.468-1.055-6.149-1.979-1.82-1-4.205-2.016-4.075-4.05.18-2.795 5.94-7.45 13.63-6.856 8.449.653 11.969 4.697 11.695 6.937zM148.545 30.94c-4.613 3.441-11.934 1.433-11.934 1.433s.163-7.585 4.779-11.023c4.613-3.44 11.931-1.436 11.931-1.436s-.162 7.586-4.776 11.026zM32.418 13.76c4.386 5.075 13.223 4.63 13.223 4.63s1.721-8.674-2.669-13.747C38.587-.432 29.754.01 29.754.01s-1.721 8.674 2.664 13.75z"
        fill="#EBF2FF"
      />
      <path
        d="M153.04 185.993a3.784 3.784 0 110-7.568 3.784 3.784 0 010 7.568zM201.139 165.23a4.16 4.16 0 11.002-8.32 4.16 4.16 0 01-.002 8.32zM120.929 38.842a3.358 3.358 0 110-6.716 3.358 3.358 0 010 6.716zM64.472 160.14a4.153 4.153 0 11-8.024 2.149 4.153 4.153 0 018.024-2.149zM108.231 20.096a5.525 5.525 0 110-11.05 5.525 5.525 0 010 11.05zM262.644 156.278c-2.347 0-4.25-1.522-4.25-3.4s1.903-3.4 4.25-3.4c2.348 0 4.25 1.522 4.25 3.4s-1.902 3.4-4.25 3.4zM22.597 166.145a6.104 6.104 0 11-12.208 0 6.104 6.104 0 0112.208 0zM228.825 149.478h.111c.659 9.328 7.596 9.472 7.596 9.472s-7.65.149-7.65 10.928c0-10.779-7.65-10.928-7.65-10.928s6.935-.144 7.593-9.472z"
        fill="#C2D7FF"
      />
    </svg>
  );
}

export default SvgUpSetting;
